import { type RefObject, useEffect } from 'react';

const isEditableTarget = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
};

/** An open modal owns the keyboard; "/" must not pull focus out from behind it. */
const isModalDialogOpen = () =>
  document.querySelector('[role="dialog"][aria-modal="true"]') !== null;

/**
 * "/" jumps to the list's search, as on every V2 list. Ignored while typing
 * in another field, when a modifier is held, or while a modal dialog is open.
 */
export function useSlashSearchShortcut(ref: RefObject<HTMLInputElement>) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (
        event.key !== '/' ||
        event.metaKey ||
        event.ctrlKey ||
        event.altKey ||
        isEditableTarget(event.target) ||
        isModalDialogOpen()
      ) {
        return;
      }
      event.preventDefault();
      ref.current?.focus();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [ref]);
}
